import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { useVoiceStudyEnabled } from "@-/dev.improve.haniverse.lib.voice-study";

/** Proof that review recharge can be spent on new cards here, so its bar applies. */
export type LearnReviewRechargeGate = Tagged<
  { readonly kind: "review-recharge" },
  "LearnReviewRechargeGate"
>;

/**
 * `null` = the designed hidden state: "Introduce New Cards" is off, a review focus is active, or
 * voice study is running — none of which ever opens a new card from reviews.
 */
export function useLearnReviewRechargeGate(): LearnReviewRechargeGate | null {
  const [introduceNewCardsEnabled] = useDeviceSetting("introduceNewCardsEnabled");
  const [reviewFocus] = useDeviceSetting("reviewFocus");
  const isVoiceActive = useVoiceStudyEnabled();
  return introduceNewCardsEnabled && reviewFocus === "all" && !isVoiceActive
    ? createGate<LearnReviewRechargeGate>({ kind: "review-recharge" })
    : null;
}
